export const RequestStatus = {
    Inprogress : {id: 1, value: "processing"},
    Success : {id: 2, value: "success"},
    Failed : {id: 3, value: "failed"},
    SuccessCr : {id: 4, value: "success"},
    FailedCr : {id: 5, value: "failed"},
}